import { Link } from 'react-router-dom'
import Footer from '../../components/Layout/Footer'
import Logo from '../../graphics/Logo'
import { setPageTitle } from '../../utils/utilities'
import CookiePolicyText from './cookiePolicyText'

const TITLE = 'Cookie Policy'
const CookiePolicy = () => {
  setPageTitle(TITLE)

  return (
    <main className="flex flex-col h-screen overflow-y-auto xl:p-5 bg-primary-gradient">
      <div className="flex flex-col gap-5 lg:w-2/3 xl:w-1/2 justify-center mb-auto md:m-auto">
        <div className="container sm:rounded-lg bg-neutral-100 dark:bg-neutral-900 w-full mx-auto p-5 shadow-lg">
          <div className="flex flex-col justify-between items-center gap-5">
            <div className="h-6 md:h-11 my-auto w-fit max-w-56">
              <Link to="/">
                <Logo />
              </Link>
            </div>
            <h1 className="font-bold text-center">{TITLE}</h1>
            <CookiePolicyText />
          </div>
        </div>
      </div>
      <Footer />
    </main>
  )
}

export default CookiePolicy
